export default {
  HOME_PAGE: "/",
};
